import { all, delay, fork, put, select, takeLatest } from 'redux-saga/effects';
import {
  ACTION_REQUEST_BUY_POINT_ORDER,
  ACTION_REQUEST_CONFIRM_TRANSACTION,
  ACTION_REQUEST_CREATE_ORDER,
  ACTION_REQUEST_CREATE_PAYMENT,
  ACTION_REQUEST_EXCHANGE_POINT_TOKEN,
  actionCreatePayment,
  buyPointToTokenOrderAPI,
  confirmTransactionAPI,
  createOrderAPI,
  createPaymentAPI,
  exchangePointToTokenAPI,
  REQUEST_BUY_POINT_ORDER_FAILURE,
  REQUEST_BUY_POINT_ORDER_SUCCESS,
  REQUEST_CONFIRM_STRIPE_SUCCESS,
  REQUEST_CONFIRM_TRANSACTION_FAILURE,
  REQUEST_CONFIRM_TRANSACTION_SUCCESS,
  REQUEST_CREATE_ORDER_FAILURE,
  REQUEST_CREATE_ORDER_SUCCESS,
  REQUEST_CREATE_PAYMENT_FAILURE,
  REQUEST_EXCHANGE_FAILURE,
  UPDATE_PAYMENT_DATA,
} from '.';
import { showToastAlert } from '../app';
import { getErrorMessage } from '../../../utils/error';
import { fetchWalletAPI } from '../profile';
import { RealtimeEventType } from '../../../constant/realtimeEvent';
import { redirect } from 'redux-first-router';
import { ROUTE_TRANSACTION_MANAGEMENT } from '../routing';

function* loadBuyPointData() {
  yield put(fetchWalletAPI());
}
function* createOrder() {
  yield takeLatest([ACTION_REQUEST_CREATE_ORDER], function* () {
    const { buyPointForHunt } = yield select();
    const { createOrderBody } = buyPointForHunt;
    yield put(createOrderAPI(createOrderBody));
  });

  yield takeLatest([REQUEST_CREATE_ORDER_SUCCESS], function* (action) {
    const orderId = action?.payload?.data?.id;
    const { buyPointForHunt } = yield select();
    const { createPaymentBody } = buyPointForHunt;

    yield put({
      type: UPDATE_PAYMENT_DATA,
      payload: {
        ...createPaymentBody,
        orderId,
      },
    });
    yield put(actionCreatePayment());
  });

  yield takeLatest([REQUEST_CREATE_ORDER_FAILURE], function* (action) {
    const messageError = action?.payload
      ? getErrorMessage(action?.payload)
      : 'Failed to create an order!';
    yield put(showToastAlert(messageError, 'error'));
  });
}

function* createPayment() {
  yield takeLatest([ACTION_REQUEST_CREATE_PAYMENT], function* () {
    const { buyPointForHunt } = yield select();
    const { createPaymentBody } = buyPointForHunt;
    yield put(createPaymentAPI(createPaymentBody));
  });

  yield takeLatest([REQUEST_CREATE_PAYMENT_FAILURE], function* (action) {
    const messageError = action?.payload
      ? getErrorMessage(action?.payload)
      : 'Failed to buy point!';
    yield put(showToastAlert(messageError, 'error'));
  });
}

function* exchangePointToken() {
  yield takeLatest([ACTION_REQUEST_EXCHANGE_POINT_TOKEN], function* (action) {
    yield put(exchangePointToTokenAPI(action.payload));
  });

  yield takeLatest([REQUEST_EXCHANGE_FAILURE], function* (action) {
    yield put(
      showToastAlert(
        getErrorMessage(action?.payload) || action.error || 'Failed to exchange!',
        'error'
      )
    );
  });
}

function* buyPointTokenOrder() {
  yield takeLatest([ACTION_REQUEST_BUY_POINT_ORDER], function* (action) {
    yield put(buyPointToTokenOrderAPI(action.payload));
  });

  yield takeLatest([REQUEST_BUY_POINT_ORDER_SUCCESS], function* () {
    yield put(showToastAlert('Your buy point order has been created successfully', 'success'));
  });

  yield takeLatest([REQUEST_BUY_POINT_ORDER_FAILURE], function* (action) {
    const messageError = action?.payload ? getErrorMessage(action?.payload) : 'Failed to exchange!';
    yield put(showToastAlert(messageError, 'error'));
  });
}

function* confirmTransaction() {
  yield takeLatest([ACTION_REQUEST_CONFIRM_TRANSACTION], function* (action) {
    yield put(confirmTransactionAPI(action.payload));
  });

  yield takeLatest(
    [
      REQUEST_CONFIRM_TRANSACTION_SUCCESS,
      RealtimeEventType.CRYPTO_PAYMENT_SUCCESS,
      RealtimeEventType.CARD_PAYMENT_SUCCESS,
    ],
    function* (action) {
      yield put(showToastAlert('Confirm transaction successfully', 'success'));

      const { buyPointForHunt } = yield select();
      const { confirmingStripe } = buyPointForHunt;
      if (
        (confirmingStripe && action.type === RealtimeEventType.CARD_PAYMENT_SUCCESS) ||
        action.type === RealtimeEventType.CRYPTO_PAYMENT_SUCCESS ||
        action.type === REQUEST_CONFIRM_TRANSACTION_SUCCESS
      ) {
        yield put({
          type: REQUEST_CONFIRM_STRIPE_SUCCESS,
        });
        yield delay(1000);

        yield put(
          redirect({
            type: ROUTE_TRANSACTION_MANAGEMENT,
          })
        );
      }
    }
  );

  yield takeLatest(
    [
      REQUEST_CONFIRM_TRANSACTION_FAILURE,
      RealtimeEventType.CRYPTO_PAYMENT_FAILED,
      RealtimeEventType.CARD_PAYMENT_FAILED,
    ],
    function* (action) {
      const messageError = getErrorMessage(action?.payload) || 'Failed to confirm transaction!';
      yield put(showToastAlert(messageError, 'error'));
    }
  );
}

export function* loadBuyPointForHuntPage() {
  yield all([
    fork(loadBuyPointData),
    fork(createOrder),
    fork(createPayment),
    fork(exchangePointToken),
    fork(buyPointTokenOrder),
    fork(confirmTransaction),
  ]);
}
